export default __webpack_public_path__ + "static/media/team7.aa30d13c.jpg";